import {useRef} from 'react'
import {Link} from 'react-router-dom'
import {FaChevronLeft, FaChevronRight} from 'react-icons/fa'
import classNames from 'classnames'
import {useMediaQuery} from "../../hooks/useMediaQuery";
import {useIsOverflow} from "../../hooks/useOverFlow";

export const ContinuePlayingComponent = ({
                                             games,
    accessToken
                                         }) => {
    const toBeIntersectedImgRef = useRef(null)
    const isLarge = useMediaQuery('(min-width:579px)')

    const scrollRef = useRef(null)

    const isOverflow = useIsOverflow(scrollRef)


    const scroll = (offSet) => {
        scrollRef.current.scrollLeft += offSet
    }


    return (
        <>
            <p className={`text-lg font-bold leading-6 sm:pl-0 pl-2 pt-4 ${process.env.REACT_APP_THEME === "dark" ? "text-white" : "text-black"}`}>
                {games.name}
            </p>

            <div className="relative">
                <div
                    className="wrapper h-36 flex overflow-y-hidden overflow-x-scroll gap-2 sm:pl-0 pl-2 scroll-smooth group"
                    id={`category-continue-playing`}
                    ref={scrollRef}
                >
                    {isOverflow && isLarge && (
                        <div
                            className={classNames(
                                `absolute hidden group-hover:block left-9 top-12 z-10 cursor-pointer carousel-button  opacity-50 transition-opacity duration-300`
                            )}
                            onClick={() => scroll(-600)}
                        >
                            <FaChevronLeft
                                className="text-white w-11 h-11 items-center align-middle rounded-full bg-black p-2.5"/>
                        </div>
                    )}
                    {games.games?.map((data, idx) => {
                        return (
                            <div key={data.uuid}>
                                <div
                                    className="w-[144px] h-[144px] aspect-square rounded-xl"
                                >
                                    <Link to={`${data.slug}${accessToken ? '?_portalToken=' + accessToken : ''}`} state={{from: '/'}}>
                                        {idx === games.games?.length - 4 && data.slug ? (
                                            <img
                                                src={data.property.thumbnail}
                                                className="w-40 h-36  rounded-xl"
                                                alt="thumbnail"
                                                ref={toBeIntersectedImgRef}
                                            />
                                        ) : (
                                            <img
                                                src={data.property.thumbnail}
                                                className="w-40 h-36 all-games-images rounded-xl"
                                                alt="thumbnail"
                                            />
                                        )}
                                    </Link>
                                </div>
                            </div>
                        )
                    })}
                    {isOverflow && isLarge && (
                        <div
                            className={`absolute hidden group-hover:block right-9 top-12 cursor-pointer items-center text-white opacity-50 transition-opacity duration-300`}
                            onClick={() => scroll(600)}
                        >
                            <FaChevronRight
                                className="text-white w-11 h-11 items-center align-middle rounded-full bg-black p-2.5"/>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}
